import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { SelectButton } from 'primereact/selectbutton';
import { InputText } from 'primereact/inputtext';

import { pesquisarProdutos, mensagemErro } from '../tributosApi';
import { SituacaoProdutoTag, formatarNcm } from '../util';

const OPCOES_CONFERIDO = [
  { label: 'Todos', value: 'T' },
  { label: 'Conferidos', value: 'S' },
  { label: 'Não conferidos', value: 'N' },
];

export default function Produtos() {
  const navigate = useNavigate();
  const [filtro, setFiltro] = useState('');
  const [conferido, setConferido] = useState('T');
  const [lista, setLista] = useState([]);
  const [carregando, setCarregando] = useState(false);

  const carregar = async () => {
    setCarregando(true);
    try {
      const termo = filtro.trim();
      const ehEan = /^\d{6,}$/.test(termo);
      const params = ehEan
        ? { codigoEan: termo }
        : { descricao: termo, conferido: conferido === 'T' ? undefined : conferido === 'S' };
      setLista(await pesquisarProdutos(params));
    } catch (e) {
      toast.error(mensagemErro(e, 'Erro ao consultar produtos.'));
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    carregar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conferido]);

  const pesquisar = e => {
    e.preventDefault();
    carregar();
  };

  const colunaIcms = p => (
    <div className="tb-cell-sub tb-mono">
      <span>{p.cstVenda ? `CST ${p.cstVenda}` : ''}{p.cstVenda && p.csosnVenda ? ' · ' : ''}{p.csosnVenda ? `CSOSN ${p.csosnVenda}` : ''}{!p.cstVenda && !p.csosnVenda ? '—' : ''}</span>
      <small>{p.icmsAliquota ? `${Number(p.icmsAliquota).toLocaleString('pt-BR')}%` : ''}{p.cfopVenda ? ` · CFOP ${p.cfopVenda}` : ''}</small>
    </div>
  );

  return (
    <div className="tb-page">
      <div className="tb-page-head">
        <div>
          <h1>Base de tributos</h1>
          <p>Cadastro fiscal dos produtos por código EAN.</p>
        </div>
        <button type="button" className="tb-btn tb-btn-primary" onClick={() => navigate('/tributos/produtos/novo')}>
          <i className="pi pi-plus" /> Novo produto
        </button>
      </div>

      <section className="tb-card">
        <form className="tb-filters" onSubmit={pesquisar}>
          <div className="tb-filters-row">
            <span className="p-input-icon-left tb-grow">
              <i className="pi pi-search" />
              <InputText value={filtro} onChange={e => setFiltro(e.target.value)} placeholder="EAN ou descrição" />
            </span>
            <SelectButton value={conferido} options={OPCOES_CONFERIDO} onChange={e => e.value && setConferido(e.value)} className="tb-segmented" />
            <button type="submit" className="tb-btn tb-btn-primary"><i className="pi pi-filter" /> Pesquisar</button>
          </div>
        </form>

        <DataTable
          value={lista}
          loading={carregando}
          paginator
          rows={25}
          rowsPerPageOptions={[25, 50, 100]}
          dataKey="id"
          responsiveLayout="stack"
          breakpoint="900px"
          emptyMessage="Nenhum produto encontrado."
          className="tb-table"
          onRowDoubleClick={e => navigate(`/tributos/produtos/${e.data.id}`)}
        >
          <Column header="EAN" body={p => p.codigoEan || <span className="tb-sem-ean" title={`CNPJ ${p.cnpjCliente || ''}`}>Reg. {p.registroProduto || '—'}</span>} bodyClassName="tb-mono" style={{ width: '11rem' }} />
          <Column header="Descrição" field="descricao" />
          <Column header="NCM" body={p => <span className="tb-mono">{p.ncm ? formatarNcm(p.ncm) : '—'}</span>} style={{ width: '9rem' }} />
          <Column header="ICMS" body={colunaIcms} style={{ width: '12rem' }} />
          <Column header="Situação" body={p => <SituacaoProdutoTag produto={p} />} style={{ width: '11rem' }} />
          <Column header="Conferido em" field="dataConferencia" style={{ width: '9rem' }} />
          <Column
            body={p => (
              <button type="button" className="tb-btn tb-btn-ghost tb-btn-sm" onClick={() => navigate(`/tributos/produtos/${p.id}`)}>
                <i className="pi pi-pencil" /> Editar
              </button>
            )}
            style={{ width: '7rem' }}
          />
        </DataTable>
      </section>
    </div>
  );
}
